module.exports = __webpack_public_path__ + "static/media/05en.8d43507d.jpg";